import { AccordionHtmlContent } from "@/components/catalogue/AccordionHtmlContent";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface ExhibitionsAccordionProps {
  exhibitionsCalculated: string;
  t: (key: string) => string;
}

export function ExhibitionsAccordion({
  exhibitionsCalculated,
  t,
}: ExhibitionsAccordionProps) {
  if (!exhibitionsCalculated?.trim()) return null;

  return (
    <AccordionItem value="expositions">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleMultipleprintDescriptionExhibitionLabel")}
      </AccordionTrigger>
      <AccordionContent>
        <AccordionHtmlContent html={exhibitionsCalculated} richText />
      </AccordionContent>
    </AccordionItem>
  );
}
